/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Detail_Toast_Regenerate_ErrorInputs */

const en_cover_letters_detail_toast_regenerate_error = /** @type {(inputs: Cover_Letters_Detail_Toast_Regenerate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to regenerate`)
};

const de_cover_letters_detail_toast_regenerate_error = /** @type {(inputs: Cover_Letters_Detail_Toast_Regenerate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neugenerierung fehlgeschlagen`)
};

const fr_cover_letters_detail_toast_regenerate_error = /** @type {(inputs: Cover_Letters_Detail_Toast_Regenerate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la régénération`)
};

const es_cover_letters_detail_toast_regenerate_error = /** @type {(inputs: Cover_Letters_Detail_Toast_Regenerate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al regenerar`)
};

const it_cover_letters_detail_toast_regenerate_error = /** @type {(inputs: Cover_Letters_Detail_Toast_Regenerate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rigenerazione non riuscita`)
};

const nl_cover_letters_detail_toast_regenerate_error = /** @type {(inputs: Cover_Letters_Detail_Toast_Regenerate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opnieuw genereren mislukt`)
};

const pl_cover_letters_detail_toast_regenerate_error = /** @type {(inputs: Cover_Letters_Detail_Toast_Regenerate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponowne generowanie nie powiodło się`)
};

const fi_cover_letters_detail_toast_regenerate_error = /** @type {(inputs: Cover_Letters_Detail_Toast_Regenerate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uudelleenluonti epäonnistui`)
};

const da_cover_letters_detail_toast_regenerate_error = /** @type {(inputs: Cover_Letters_Detail_Toast_Regenerate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke genskabe`)
};

const sv_cover_letters_detail_toast_regenerate_error = /** @type {(inputs: Cover_Letters_Detail_Toast_Regenerate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte generera om`)
};

/**
* | output |
* | --- |
* | "Failed to regenerate" |
*
* @param {Cover_Letters_Detail_Toast_Regenerate_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_detail_toast_regenerate_error = /** @type {((inputs?: Cover_Letters_Detail_Toast_Regenerate_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Detail_Toast_Regenerate_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_detail_toast_regenerate_error(inputs)
	if (locale === "fr") return fr_cover_letters_detail_toast_regenerate_error(inputs)
	if (locale === "es") return es_cover_letters_detail_toast_regenerate_error(inputs)
	if (locale === "it") return it_cover_letters_detail_toast_regenerate_error(inputs)
	if (locale === "nl") return nl_cover_letters_detail_toast_regenerate_error(inputs)
	if (locale === "pl") return pl_cover_letters_detail_toast_regenerate_error(inputs)
	if (locale === "fi") return fi_cover_letters_detail_toast_regenerate_error(inputs)
	if (locale === "da") return da_cover_letters_detail_toast_regenerate_error(inputs)
	if (locale === "sv") return sv_cover_letters_detail_toast_regenerate_error(inputs)
	return en_cover_letters_detail_toast_regenerate_error(inputs)
});